let defaultMeetingResult = {
    title: '',
    order: 0,
};

export default defaultMeetingResult;
